import React, { FC } from 'react';

import { ChildrenProps } from '../../../utils';

import './Content.scoped.scss';

const Content: FC<ChildrenProps> = ({ children }) => {
  return <div className="content">{children}</div>;
};

export default Content;
